import DateRangePicker from '@wojtekmaj/react-daterange-picker'
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css'
import dayjs from 'dayjs'
import { useEffect, useRef, useState } from 'react'
import 'react-calendar/dist/Calendar.css'
import { useParams } from 'react-router'
import DayViewCalendarComponent from 'src/clinic/components/ClinicManageBookingsPage/DayViewCalendarComponent'
import { fetchAndProcessBookedSlots } from 'src/clinic/components/ClinicManageBookingsPage/utils'
import { getCPDataWithParams } from 'src/clinic/services'
import { MOMENT_FORMATS } from 'src/consumer/constants'
import HeaderItems from 'src/mentor/components/MentorClinicBookingsPage/component/HeaderItems'
import { MENTOR_CLINIC_BOOKING_TABS } from 'src/mentor/components/MentorClinicBookingsPage/util'
import {
  getDataMapFromCommonResponse,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'
import SupportHeader from 'src/supportPortal/layout/SupportHeader'
import { getSPDataWithParams } from 'src/supportPortal/services/services'

export default function SupportClinicBookings() {
  const { clinicSlug } = useParams()
  const [bookings, setBookings] = useState([])
  const [startDate, setStartDate] = useState(dayjs())
  const [endDate, setEndDate] = useState(dayjs())
  const [clinicLocation, setClinicLocation] = useState()
  const [clinicBrand, setClinicBrand] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [popoverAnchor, setPopoverAnchor] = useState(null)
  const [clinicAppointmentTypes, setClinicAppointmentTypes] = useState([])
  const [selectedMentor, setSelectedMentor] = useState({
    id: 'un-assigned',
    name: 'Un-Assigned Mentor',
    firstName: 'Un-Assigned Mentor',
  })
  const [selectedClinicAppointmentType, setSelectedClinicAppointmentType] = useState()
  const [mentors, setMentors] = useState([])
  const calendarRef = useRef(null)
  const validMentorIds = [
    ...(clinicLocation?.doctors?.map((doc) => doc?.uid) || []),
    ...(clinicLocation?.therapists?.map((therapist) => therapist?.uid) || []),
  ]

  async function getClinicLocation() {
    const resp = await getCPDataWithParams('/api/secure/cc/support/clinic/by-slug', {
      'clinic-slug': clinicSlug,
      sendBrandDetails: true,
    })
    let clinic = null
    let brand = null
    if (resp.status === 200 && isCommonResponseSuccessfulV2(resp)) {
      const data = getDataMapFromCommonResponse(resp)
      clinic = data?.['clinic']
      brand = data?.['clinic-brand']
    }
    setClinicLocation(clinic)
    setClinicBrand(brand)
    return { clinic, brand }
  }

  async function getUnassignedBookings({
    from,
    to,
    clinicBrandId = null,
    clinicLocationId = null,
    mentorId = null,
    clinicAppointmentTypeId = null,
  }) {
    const eventDataResponse = await fetchAndProcessBookedSlots({
      apiSignature:
        mentorId !== 'un-assigned'
          ? `/api/secure/cc/support/events/booked-slots/all-with-patient-info?mentorId=${mentorId}`
          : `/api/secure/cc/support/clinic/un-assigned-bookings/list?clinic-brand-id=${clinicBrandId}
        &clinic-location-id=${clinicLocationId}&from=${from.format(
              MOMENT_FORMATS.javaLocalDateFormat,
            )}&to=${to.format(MOMENT_FORMATS.javaLocalDateFormat)}`,
      startTime: from.format(MOMENT_FORMATS.javaLocalDateFormat),
      endTime: to.format(MOMENT_FORMATS.javaLocalDateFormat),
      timeZone: 'Asia/Kolkata',
      forMentor: true,
    })
    if (eventDataResponse !== null) {
      const bookedSlots = eventDataResponse?.bookedSlotWithPatientInfo?.filter((slot) => {
        if (clinicAppointmentTypeId) {
          return slot?.eventTypeId === clinicAppointmentTypeId
        }
        return true
      })
      setBookings(bookedSlots)
    }
    // const resp = await getCPDataWithParams(
    //   '/api/secure/cc/support/clinic/unassigned-bookings/list',
    //   {
    //     'clinic-brand-id': clinicBrandId,
    //     'clinic-location-id': clinicLocationId,
    //     from: from.format(MOMENT_FORMATS.javaLocalDateFormat),
    //     to: to.format(MOMENT_FORMATS.javaLocalDateFormat),
    //   },
    // )
    // if (resp.status === 200 && isCommonResponseSuccessfulV2(resp)) {
    //   const data = getDataMapFromCommonResponse(resp)
    //   setUnassignedBookings(data?.['booked-event-info'])
    // }
  }

  async function getClinicServicesForThisClinicLocation({ locationId, brandId }) {
    const resp = await getCPDataWithParams(
      '/api/secure/cc/support/clinic/clinic-appointment-type/list',
      {
        clinicId: locationId,
        clinicBrandId: brandId,
      },
    )
    if (resp.status === 200) {
      if (isCommonResponseSuccessfulV2(resp)) {
        const data = getDataMapFromCommonResponse(resp)
        setClinicAppointmentTypes(data.appointmentTypes)
      }
    }
  }

  async function getDataWithSortPageOrSize(from, to, mentorId, clinicAppointmentTypeId) {
    setIsLoading(true)
    const fromDate = from ? dayjs(from) : startDate
    const toDate = to ? dayjs(to) : endDate
    const mntrId = mentorId || selectedMentor
    const clnApptTypeId = clinicAppointmentTypeId || selectedClinicAppointmentType || null

    setStartDate(fromDate)
    setEndDate(toDate)
    setSelectedMentor(mntrId)
    setSelectedClinicAppointmentType(clnApptTypeId)

    // await getUnassignedBookings({
    //   from: fromDate,
    //   to: toDate,
    //   clinicBrandId: clinicBrand?.id,
    //   clinicLocationId: clinicLocation?.id,
    //   mentorId: mntrId,
    //   clinicAppointmentTypeId: clnApptTypeId,
    // })
    setIsLoading(false)
  }

  async function setup() {
    setIsLoading(true)
    const { clinic, brand } = await getClinicLocation()
    await Promise.all([
      getClinicServicesForThisClinicLocation({
        locationId: clinic?.id,
        brandId: brand?.id,
      }),
      getTherapistsList(),
      // getUnassignedBookings({
      //   from: startDate,
      //   to: endDate,
      //   clinicBrandId: brand?.id,
      //   clinicLocationId: clinic?.id,
      // }),
    ])
    setIsLoading(false)
  }

  function createNewUnassignedBooking() {
    // setPopoverAnchor(e.currentTarget)
  }

  async function getTherapistsList() {
    const resp = await getSPDataWithParams('/api/secure/cc/support/all-doctors-therapists/list')
    if (resp.status === 200) {
      if (isCommonResponseSuccessfulV2(resp)) {
        const mentorsList = getDataMapFromCommonResponse(resp)?.mentor
        setMentors(mentorsList)
      }
    }
  }

  function refreshListingData() {
    calendarRef?.current?.getAndSetBookedSlotsOfSelectedDate()
  }

  useEffect(() => {
    setup()
  }, [])

  console.log({ selectedClinicAppointmentType })

  return (
    <>
      <SupportHeader
        heading={`${clinicBrand?.brandName || clinicBrand?.title} ${
          clinicLocation?.title ? ` ${clinicLocation?.title}` : ''
        } - Bookings`}
        showBackButton
      >
        <HeaderItems
          clinicBrandId={clinicBrand?.id}
          clinicId={clinicLocation?.id}
          clinicAssociationData={[]}
          selectedTab={MENTOR_CLINIC_BOOKING_TABS.calendar.id}
          setSelectedTab={() => {}}
          mentorProfileData={selectedMentor}
          hideTabs
          hideClinicDetails
          hideCheckinDetails
          searchPatientApiSignature={`/api/secure/cc/support/patient/search`}
          refreshData={refreshListingData}
          mentorsList={mentors?.filter((mntr) => {
            if (mntr?.id && validMentorIds.includes(mntr?.id)) {
              return true
            }
            return false
          })}
          // refreshData={refreshData}
          hideRefreshButton
          appointmentTypesList={clinicAppointmentTypes}
          createPatientApiSignature={`/api/secure/cc/support/patient/new`}
        />
      </SupportHeader>
      <div className="px-4 py-0 d-flex justify-content-between align-items-center gap-2" style={{ marginTop: 0, paddingTop: 0 }}>
        {/* <CustomSelect
          id="clinic-appointment-type"
          value={selectedClinicAppointmentType}
          label="Clinic Appointment Type"
          placeholder="Select Clinic Appointment Type"
          getOptionValue={(option) => option?.id}
          getOptionLabel={(option) => option?.title}
          isLoading={isLoading}
          options={clinicAppointmentTypes}
          selectType={selectTypes.string}
          onChangeEvent={(e) => {
            getDataWithSortPageOrSize(null, null, null, e.target.value)
          }}
        /> */}
        {/* <CustomSelect
          id="mentor"
          value={selectedMentor}
          label="Mentor"
          placeholder="Select Mentor"
          isLoading={isLoading}
          options={[
            {
              id: 'un-assigned',
              name: 'Un-Assigned',
            },
            ...mentors,
          ]}
          onChangeEvent={(e) => {
            getDataWithSortPageOrSize(null, null, e.target.value)
          }}
          selectType={selectTypes.string}
          getOptionValue={(option) => option?.id}
          getOptionLabel={(option) => option?.name}
        /> */}
      </div>
      <div className="px-4 py-0 d-flex justify-content-between align-items-center" style={{ marginTop: 0, paddingTop: 0 }}>
        <DateRangePicker
          clearIcon={null}
          onChange={(val) => {
            getDataWithSortPageOrSize(dayjs(val?.[0]), dayjs(val?.[1]), selectedMentor)
          }}
          value={[startDate.toDate(), endDate.toDate()]}
        />
      </div>
      <div className="px-4" style={{ marginTop: 0, paddingTop: 0 }}>
        <DayViewCalendarComponent
          forMentor={false}
          // currentView={MENTOR_CLINIC_BOOKING_TABS.appointments.id}
          ref={calendarRef}
          selectedTab={MENTOR_CLINIC_BOOKING_TABS.calendar.id}
          eventTypesListOverride={clinicAppointmentTypes
            ?.filter((apptType) => apptType?.id === selectedClinicAppointmentType)
            ?.map((apptType) => ({
              ...apptType,
              uid: apptType?.id,
            }))}
          patientSearchApiSignature={`/api/secure/cc/support/patient/search`}
          cancelAppointmentApiSignature={`/api/secure/cc/support/therapist/meeting/booked-slot/cancel`}
          editBookingApiSignature={`/api/secure/cc/support/events/edit`}
          pastPatientBookingsApiSignature={`/api/secure/cc/support/therapist/meeting/booked-slots/patient`}
          createPatientApiSignature={`/api/secure/cc/support/patient/new`}
          patientUpdateApiSignature="/api/secure/cc/support/patient/update"
          patientTagsApiSignature="/api/secure/cc/support/patient/tags"
          bookingLisitingApiSignature={
            selectedMentor?.id !== 'un-assigned'
              ? `/api/secure/cc/support/events/booked-slots/all-with-patient-info?mentorId=${selectedMentor?.id}&doctorId=${selectedMentor?.id}`
              : `/api/secure/cc/support/clinic/un-assigned-bookings/list?clinic-brand-id=${clinicBrand?.id}&clinic-location-id=${clinicLocation?.id}`
          }
          mentorId={selectedMentor?.id}
          hideMentorSelection
          hideScrollToTopButton
          mentorProfileData={selectedMentor}
          useClinicServices
          thisClinicData={clinicLocation}
          // mentorClinicAssociationData={assistantData?.associatedClinicsData}
          // allProfessionalsDataForAssistant={mentors}
          canPersonPrintPrescription={false}
          // chambersData={assistantData?.associatedChamberRoomsData}
          // assistantProfileInThisClinic={assistantProfileForThisClinic}
          clinicAppointmentTypesList={clinicAppointmentTypes}
          mentorsList={[
            {
              id: 'un-assigned',
              name: 'Un-Assigned Mentor',
              firstName: 'Un-Assigned Mentor',
            },
            ...mentors?.filter((mntr) => {
              console.log({ validMentorIds })
              if (mntr?.id && validMentorIds.includes(mntr?.id)) {
                return true
              }
              return false
            }),
          ]}
          bookWithUnassignedMentor={selectedMentor?.id === 'un-assigned'}
          onChangeMentorProfileData={(profileData) => {
            setSelectedMentor(profileData)
          }}
        />
        {/* <ConsultsTab bookedEventsListWithPatientInfo={bookings} loadingTableData={isLoading} /> */}
      </div>
    </>
  )
}
